export default {
	common_inactivity_warning: "Du har snart v\u00E6ret inaktiv i systemet i 1 time og vil blive logget af om mindre end {{minutes}} minut(ter). Klik et sted p\u00E5 siden for at undg\u00E5 dette.",
	common_relogin_title: "Log ind"
};
